export const ReviewsUS = {
  TITLE: 'Reviews',
  REVIEW: [
    {
      image: 'star.svg',
      paragraph:
        'Really good quality. I live in Arizona so it’s pretty dry and my contacts stay in. They feel great and I love how they are so cost effective.',
      reviewerName: 'Rachel',
      alt: 'star',
    },
    {
      image: 'star.svg',
      paragraph:
        'Great product! I have super dry eyes, but I am able to wear the contacts comfortably. The customer service has been prompt and polite. I highly recommend!!',
      reviewerName: 'Merilee Adams',
      alt: 'star',
    },
    {
      image: 'star.svg',
      paragraph:
        'My shopping experience with WALDO has been great from the start. I have tried nearly every other daily contact subscription service and this one is the best so far.',
      reviewerName: 'T Roberts',
      alt: 'star',
    },
  ],
  BUSINESS_REVIEW: [
    {
      image: 'business_insider.svg',
      businessParagraph:
        '"WALDO sells daily contact lenses online, but for less than the big brands. The lenses are delivered to customers\' doors within 48 hours, in compact, chic and recyclable packaging."',
      alt: 'Business insider',
    },
    {
      image: 'gq.svg',
      businessParagraph:
        '"The tailored prescription contacts can be delivered on demand or on a monthly basis, making it the perfect hassle-free option."',
      alt: 'GQ',
    },
    {
      image: 'forbes.svg',
      businessParagraph:
        '"WALDO\'s emphasis on quality is a distinguishing factor: the company offers lenses that are higher in moisture content and low in friction, provide UV protection and allow more oxygen to the eye, priced at 40-50% lower than competitors."',
      alt: 'Forbes',
    },
  ],
};
